import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL } from '../constants/apiConstants';
import axiosInstance from '../api/axios';

const initialState: any = {
  menuBridger: [],
  isexcluded: false,
  deliverydate: {},

  bridgerMappingList: [],
  bridgerMappingListLoading: false,
  bridgerMappingListError: null,

  bridgerAllDishes: [],
  bridgerAllDishesLoading: false,
  bridgerAllDishesError: null,

  loading: false,
  daypartLoading: false,
  error: null,
};



export const GetBridger = createAsyncThunk(
  'bridgerMenu/GetBridgerMapping',
  async (payload: any) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/Bridger/GetBridgerMapping`, payload);
    return response?.data?.data;
  }
);

export const GetBridgerMappingList = createAsyncThunk(
  'bridgerMenu/GetBridgerMappingList',
  async (payload: {
    userid: string;
    isitemuser: boolean;
    useridvalue: number;
    plandate: string;
    sitecode: string;
    daypartcodes: string[];
  }) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/Bridger/GetBridgerMappingList`, payload);
    return response?.data?.data;
  }
);

export const ConfirmBridgerData = createAsyncThunk(
  'bridgerMenu/ConfirmBridgerData',
  async (payload: {
    productiondate: string;
    sitecode: string;
    daypartcode: string | null;
    itemcode: string | null;
    userid: string;
    useridvalue: number;
  }) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/Bridger/ConfirmBridgerData`, payload);
    return response?.data;
  }
);

export const GetBridgerAllDishes = createAsyncThunk(
  'bridgerMenu/GetBridgerAllDishes',
  async (payload: {
    plandate: string;
    sitecode: string;
    userid: string;
    useridvalue: number;
  }) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/Bridger/GetBridgerAllDishes`, payload);
    return response?.data?.data;
  }
);
// export const getMenuRequisitionDaypart = createAsyncThunk(
//   'bridgerMenu/GetMenuRequisitionDaypart',
//   async (payload: any) => {
//     const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/MenuRequisition/GetMenuRequisition`, payload);
//     return response?.data?.data;
//   }
// );




const bridgerMenuSlice = createSlice({
  name: 'bridgerMenu',
  initialState,
  reducers: {
    updateRevenuePerDay: (state, action) => {
      state.revenueInfo.revenuePerDay = action.payload;
    },
    resetState: () => initialState, // Reset state to initial values
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetBridger.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetBridger.fulfilled, (state, action) => {
        state.loading = false;
        state.menuBridger = action.payload;
        state.isexcluded = action.payload.isexcluded;
      })
      .addCase(GetBridger.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(GetBridgerMappingList.pending, (state) => {
        state.bridgerMappingListLoading = true;
        state.bridgerMappingListError = null;
      })
      .addCase(GetBridgerMappingList.fulfilled, (state, action) => {
        state.bridgerMappingListLoading = false;
        state.bridgerMappingList = action.payload;
      })
      .addCase(GetBridgerMappingList.rejected, (state, action) => {
        state.bridgerMappingListLoading = false;
        state.bridgerMappingListError = action.error.message;
      });

    builder
      .addCase(ConfirmBridgerData.pending, (state) => {
        state.loading = true;
      })
      .addCase(ConfirmBridgerData.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(ConfirmBridgerData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(GetBridgerAllDishes.pending, (state) => {
        state.bridgerAllDishesLoading = true;
        state.bridgerAllDishesError = null;
      })
      .addCase(GetBridgerAllDishes.fulfilled, (state, action) => {
        state.bridgerAllDishesLoading = false;
        state.bridgerAllDishes = action.payload;
      })
      .addCase(GetBridgerAllDishes.rejected, (state, action) => {
        state.bridgerAllDishesLoading = false;
        state.bridgerAllDishesError = action.error.message;
      });

    // //update only daypart
    // builder
    //   .addCase(getMenuRequisitionDaypart.pending, (state) => {
    //     state.daypartLoading = true;
    //   })
    //   .addCase(getMenuRequisitionDaypart.fulfilled, (state, action) => {
    //     const updatedDaypart = action.payload.daypartmenulist[0];
    //     state.menuRequisition = state.menuRequisition.map((plan: any) =>
    //       plan.daypartcode === updatedDaypart.daypartcode
    //         ? { ...plan, ...updatedDaypart } // Update matching object
    //         : plan // Keep unchanged objects
    //     );
    //     state.daypartLoading = false;
    //   })
    //   .addCase(getMenuRequisitionDaypart.rejected, (state) => {
    //     state.daypartLoading = false;
    //   });

    // builder
    //   .addCase(getMenuRequisitionFoodProgram.pending, (state) => {
    //     state.loading = true;
    //   })
    //   .addCase(getMenuRequisitionFoodProgram.fulfilled, (state, action) => {
    //     state.loading = false;
    //     state.menuRequisition = action.payload.daypartmenulist;
    //     state.isexcluded = action.payload.isexcluded;
    //   })
    //   .addCase(getMenuRequisitionFoodProgram.rejected, (state, action) => {
    //     state.loading = false;
    //     state.error = action.error.message;
    //   });

    //update only daypart
    // builder
    //   .addCase(getMenuRequisitionFoodProgramDaypart.pending, (state) => {
    //     state.daypartLoading = true;
    //   })
    //   .addCase(getMenuRequisitionFoodProgramDaypart.fulfilled, (state, action) => {
    //     const updatedDaypart = action.payload.daypartmenulist[0];
    //     state.menuRequisition = state.menuRequisition.map((plan: any) =>
    //       plan.daypartcode === updatedDaypart.daypartcode
    //         ? { ...plan, ...updatedDaypart } // Update matching object
    //         : plan // Keep unchanged objects
    //     );
    //     state.daypartLoading = false;
    //   })
    //   .addCase(getMenuRequisitionFoodProgramDaypart.rejected, (state) => {
    //     state.daypartLoading = false;
    //   });

    // builder
    //   .addCase(getMenuRequisitionCombo.pending, (state) => {
    //     state.loading = true;
    //   })
    //   .addCase(getMenuRequisitionCombo.fulfilled, (state, action) => {
    //     state.loading = false;
    //     state.menuRequisition = action.payload.daypartmenulist;
    //     state.isexcluded = action.payload.isexcluded;
    //   })
    //   .addCase(getMenuRequisitionCombo.rejected, (state, action) => {
    //     state.loading = false;
    //     state.error = action.error.message;
    //   });

    // //update only daypart
    // builder
    //   .addCase(getMenuRequisitionComboDaypart.pending, (state) => {
    //     state.daypartLoading = true;
    //   })
    //   .addCase(getMenuRequisitionComboDaypart.fulfilled, (state, action) => {
    //     const updatedDaypart = action.payload.daypartmenulist[0];
    //     state.menuRequisition = state.menuRequisition.map((plan: any) =>
    //       plan.daypartcode === updatedDaypart.daypartcode
    //         ? { ...plan, ...updatedDaypart } // Update matching object
    //         : plan // Keep unchanged objects
    //     );
    //     state.daypartLoading = false;
    //   })
    //   .addCase(getMenuRequisitionComboDaypart.rejected, (state, action) => {
    //     state.daypartLoading = false;
    //   });

    // builder
    //   .addCase(fetchRevenueInfo.fulfilled, (state, action) => {
    //     // state.loading = false;
    //     state.revenueInfo.revenuePerDay = action.payload.revenueperday;
    //     state.revenueInfo.theoPerDay = action.payload.theocost;
    //     state.revenueInfo.ispublished = action.payload.ispublished;
    //   })
    //   .addCase(fetchRevenueInfo.rejected, (state, action) => {
    //     // state.loading = false;
    //     state.error = action.error.message;
    //   });

  },
});

export const { updateRevenuePerDay, resetState } = bridgerMenuSlice.actions;
export default bridgerMenuSlice.reducer;
